import { Component, OnInit, ViewEncapsulation, HostBinding, Input } from '@angular/core';
import { IUProperty } from 'src/app/shared/interface/umbraco-property';
import { ButtonData } from '../lib/helper/button-data';
import { UProperty } from '../lib/public_api';
import { ILinksBlockData } from './links-block/links-block.component';

export interface ILinksPanelData {
  title: IUProperty<string>;
  links: IUProperty<ButtonData[]>;
  anchor: IUProperty<string>;
}
@Component({
  selector: 'app-links-panel',
  templateUrl: './links-panel.component.html',
  styleUrls: ['./links-panel.component.less'],
  encapsulation: ViewEncapsulation.None
})
export class LinksPanelComponent implements OnInit {
  @Input() data: ILinksPanelData | null;
  blockLinksData: ILinksBlockData;

  @HostBinding('class') hostClass = 'app-links-panel';
  ngOnInit()
  {
    this.blockLinksData = UProperty.extract<ILinksPanelData, ILinksBlockData>(this.data, ['title', 'links'])
  }
}
